import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useCompany } from '../../../components/context/CompanyContext';


const ContactInformationCard = () => {
  const { company } = useCompany();
  const salonInfo = {
    phone: company?.phoneNumber,
    email: company?.email ?? '',
    address: company?.address
  };

  const handleCall = () => {
    window.location.href = `tel:${salonInfo?.phone}`;
  };

  const handleEmail = () => {
    window.location.href = `mailto:${salonInfo?.email}`;
  };

  const handleDirections = () => {
    const encodedAddress = encodeURIComponent(salonInfo?.address);
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 border border-border shadow-sm animate-fade-in">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
          <Icon name="MapPin" size={24} color="white" />
        </div>
        <h2 className="font-heading font-semibold text-2xl text-foreground">
          Contact Information
        </h2>
      </div>

      <div className="space-y-4">
        <div className="flex items-start gap-3 p-4 bg-muted/50 rounded-lg">
          <Icon name="Phone" size={20} className="text-primary mt-1 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-muted-foreground font-caption mb-1">Phone</p>
            <p className="font-caption font-medium text-base text-foreground mb-2">
              {salonInfo?.phone}
            </p>
            <Button
              onClick={handleCall}
              variant="outline"
              size="sm"
              iconName="Phone"
            >
              Call Now
            </Button>
          </div>
        </div>

        <div className="flex items-start gap-3 p-4 bg-muted/50 rounded-lg">
          <Icon name="Mail" size={20} className="text-primary mt-1 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-muted-foreground font-caption mb-1">Email</p>
            <p className="font-caption font-medium text-base text-foreground mb-2 break-all">
              {salonInfo?.email}
            </p>
            <Button
              onClick={handleEmail}
              variant="outline"
              size="sm"
              iconName="Mail"
            >
              Send Email
            </Button>
          </div>
        </div>

        <div className="flex items-start gap-3 p-4 bg-muted/50 rounded-lg">
          <Icon name="MapPin" size={20} className="text-primary mt-1 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-muted-foreground font-caption mb-1">Address</p>
            <p className="font-caption font-medium text-base text-foreground mb-2">
              {salonInfo?.address}
            </p>
            <Button
              onClick={handleDirections}
              variant="outline"
              size="sm"
              iconName="Navigation"
            >
              Get Directions
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInformationCard;